<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>基础数据</el-breadcrumb-item>
        <el-breadcrumb-item>院校管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">院校管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleToCategory"
          >分类管理</el-button>
          <el-button
            class="button"
            type="primary"
            @click="handleCollegeCreate"
          >添加院校</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="院校名称"
          prop="keyword"
        >
          <el-input
            v-model="query.keyword"
            placeholder="输入院校名称/代码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="地区"
          prop="province_code"
        >
          <el-select
            v-model="query.province_code"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.provinces"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分类"
          prop="category_id"
        >
          <el-select
            v-model="query.category_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            v-model="query.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="院校名称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="code"
            label="院校代码"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="logo"
            label="标志"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.logo"
                style="max-height: 50px;display: block;margin: 0 auto;"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="province_name"
            label="地区"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="category_ids"
            label="院校分类"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{renderCategoryName(scope.row.category_ids)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToCollegeEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleToAcademy(scope.row, scope.$index)"
              >学院列表</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleToMajor(scope.row, scope.$index)"
              >专业列表</el-button>
              <!-- <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToCollegeRemove(scope.row, scope.$index)">删除</el-button> -->
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToCollegeEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="b"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAcademy(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      学院列表
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToMajor(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      专业列表
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <CollegeCreate
      :visible="createDialog"
      :provinces="provinces"
      @close="createDialog = false"
      @submit="fetchCollegeList"
    ></CollegeCreate>
    <CollegeEdit
      :visible="editDialog"
      :content="editRow"
      :provinces="provinces"
      @close="editDialog = false"
      @submit="fetchCollegeList"
    ></CollegeEdit>
  </div>
</template>

<script>
import CollegeCreate from '@/components/dialog/college/CollegeCreate'
import CollegeEdit from '@/components/dialog/college/CollegeEdit'
import { provinceList, collegeList, collegeDestroy, collegeCategoryList } from '@/api/common'
import { computePermission } from "@/utils/helper"

export default {
  components: {
    CollegeCreate,
    CollegeEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        keyword: '',
        status: '',
        province_code: '',
        category_id: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '关闭', value: '0' }
        ],
        provinces: []
      },
      provinces: [],
      categorys: [],
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.parseQuery()
    this.fetchCategoryList()
    this.fetchProvinceList()
    this.fetchCollegeList()
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      collegeCategoryList({ isPaging: 0 }).then(res => {
        let list = res.list
        list.unshift({ id: '', name: '全部' })
        this.categorys = res.list
      })
    },
    // 院校列表请求
    fetchCollegeList() {
      collegeList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 省份列表请求
    fetchProvinceList() {
      provinceList().then(res => {
        let list = [{ code: '', name: '全部' }, ...res.list]
        this.filter.provinces = list
        this.provinces = res.list
      })
    },
    // 分类名称渲染
    renderCategoryName(ids) {
      if (!ids) {
        return ''
      }
      ids = ids.split(',')
      const list = this.categorys.filter(item => ids.includes(String(item.id)))
      if (list.length) {
        return list.map(v => v.name).join('、')
      }
      return ''
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchCollegeList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchCollegeList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchCollegeList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchCollegeList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/college/category`)
    },
    // 院校创建
    handleCollegeCreate() {
      this.createDialog = true
    },
    // 院校编辑
    handleToCollegeEdit(row) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      this.editDialog = true
    },
    // 院校删除
    handleToCollegeRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        collegeDestroy({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchCollegeList()
        })
      }).catch(() => { })
    },
    // 院校学院列表
    handleToAcademy(row) {
      this.$router.push(`/college/${row.id}/academy`)
    },
    // 院校专业列表
    handleToMajor(row) {
      this.$router.push(`/college/${row.id}/major`)
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
    //按钮权限
    compute(val) {
      return computePermission(val)
    }
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
